import React, { useEffect } from 'react'
import AppNavbar from '../../components/Navbar'
import { useNavigate } from 'react-router-dom'
import { Link } from 'react-router-dom';
import { Container, Navbar, Nav, Button, NavDropdown, Form , Col, Row, Offcanvas, Spinner, Card} from 'react-bootstrap';
import ProfileNavbar from '../../components/ProfileNavbar';
import logo from '../../images/logo.svg'
import caramel from '../../images/caramel.svg'
import './profile.css'
import { dashboard } from '../../data';



const Profile = ({handleLogout, userData, setUserData}) => {
   const navigate = useNavigate();
  
   const persistUserData = (userData) => {
    localStorage.setItem('userData', JSON.stringify(userData));
  };

  useEffect(() => {
    // Check if user data is available in localStorage
    const storedUserData = JSON.parse(localStorage.getItem('userData'));
    if (storedUserData) {
      // Set user data from localStorage if available
      setUserData(storedUserData);
    }
  }, []); // Run this effect only once on component mount

  // Update localStorage whenever userData prop changes
  useEffect(() => {
    if (userData) {
      persistUserData(userData);
    }
  }, [userData]);


   const handleLogoutClick=()=> {
    handleLogout();
    navigate('/login');
   }
   ;

   if (userData){
    const {name,email}= userData
   
    return (
      <div>
     
  <Container fluid style={{background:'#F9F9F9'}} className='p-3 px-md-5'>
    <div className='pt-md-5 pb-5'>
    <div className='d-flex gap-3 align-items-center px-md-5'>
    <img src={caramel} className='' alt='caramel' style={{width:'100px', height:'100px'}}/>
      
         <div className='mt-3'>
          <h6 className='username-2'>{name}</h6>
          <p className='email-add-2'>{email}</p>
         </div>
    </div>
    
    <Row className='mt-5 px-md-5'>
     
      {dashboard.map((dashcards) => {
        const {id,icon,header,info} = dashcards;
        return (
          <Col lg={4} md={6} xs={12} className='mb-3 ' key={id}>
            
          <Card className='p-5 align-items-center text-align-center' style={{background: '#fff', height:'100%'}} >
          <div >
          <div className='align-items-center text-center'>

          <img src={icon} alt='icon' className=''/>
            <h4 className='dashboard-header mt-4'>{header}</h4> <p className='dashboard-info mt- text-align-center'>{info}</p>
    </div>
  
          </div>
         
          
          </Card>
          
          </Col>
       
        )
      })}
      
    </Row>
    <div className='text-center mt-3'>
    <Button onClick={() => navigate('/signup')} style={{height: '48px',
 width: '300px',
 
 borderRadius: '8px',
 
 backgroundColor: '#008080', fontSize:'20px'}} className='text-center mt-5'>
          Deactivate Account
         </Button>
         </div>
    </div>
      
  </Container>
     
      
      
    </div>
    )
   }
 
  return (
    
     <div>
     


    <Container fluid style={{background:'#F9F9F9'}} className='p-3 px-md-5'>
    <div className='pt-md-5 pb-5'>
    <div className='d-flex gap-3 align-items-center px-md-5'>
    <img src={caramel} className='' alt='caramel' style={{width:'100px', height:'100px'}}/>
      
         <div className='mt-3'>
         <Spinner animation="border" role="status">
      <span className="visually-hidden">Loading...</span>
    </Spinner>
         </div>
    </div>
    
    <Row className='mt-5 px-md-5'>
     
      {dashboard.map((dashcards) => {
        const {id,icon,header,info} = dashcards;
        return (
          <Col lg={4} md={6} xs={12} className='mb-3 ' key={id}>
            
          <Card className='p-5 align-items-center text-align-center' style={{background: '#fff', height:'100%'}} >
          <div >
          <div className='align-items-center text-center'>

          <img src={icon} alt='icon' className=''/>
            <h4 className='dashboard-header mt-4'>{header}</h4> <p className='dashboard-info mt- text-align-center'>{info}</p>
    </div>
  
          </div>
         
          
          </Card>
          
          </Col>
       
        )
      })}
      
    </Row>
    <div className='text-center mt-3'>
    <Button onClick={() => navigate('/signup')} style={{height: '48px',
 width: '300px',
 
 borderRadius: '8px',
 
 backgroundColor: '#008080', fontSize:'20px'}} className='text-center mt-5'>
          Deactivate Account
         </Button>
         </div>
    </div>
      
  </Container>
  
 </div>
  )
}

export default Profile
